import React from 'react'

class Router extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const viewStr = this.props.getView();
        const routes = this.props.routes;
        //console.log(routes);
        let View;
        //console.log(viewStr);
        if (!viewStr) {
            View = routes['*'];
        } else {
            View = routes[viewStr];
        }

        if (!View) {
            return (
                <div>
                    ROUTE NOT FOUND!
                </div>
            )
        }
        return <View />
    }
}

export default Router;